<template>
  <div>
    <div class="eu-flex">
      <div class="eu-flex-item eu-basis_12 eu-basis_8_md">
        <Items @formIsValid="formValidation" />
        <Shipping />
      </div>
      <div class="eu-flex-item eu-basis_12 eu-basis_4_md">
        <Summary />
      </div>
    </div>
    <div class="el-section">
      <div class="eu-display_flex">
        <button
          class="emd-btn _color_secondary _type_text _block_mobile"
          @click="goBack"
        >
          <i class="uil uil-angle-left"></i>
          {{ $t("back") }}
        </button>
        <button
          class="emd-btn _color_secondary _block_mobile eu-ml_auto"
          @click="next"
        >
          {{ $t("next") }}
          <i class="uil uil-angle-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Shipping from './PaymentLink/Shipping.vue'
import Items from './PaymentLink/Items.vue'
import Summary from '../../components/project/Summary/Summary.vue'

export default {
  name: 'PaymentLink',
  components: {
    Shipping,
    Items,
    Summary
  },
  data () {
    return {
      formIsValid: false
    }
  },
  computed: {
    routesWizard () {
      return this.$store.getters.routesWizard
    },
    showFeedbacks: {
      get () {
        return this.$store.getters.showFeedbacks
      },
      set (newValue) {
        this.$store.dispatch('SHOW_FEEDBACK_STATUS', newValue)
      }
    },
    hasSubscriptionEnabled () {
      return this.$store.getters.hasSubscriptionEnabled
    }
  },
  methods: {
    scrollToTop () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },
    formValidation (value) {
      this.formIsValid = value
      if (!this.formIsValid) this.showFeedbacks.status = false
    },
    goBack () {
      this.$store.dispatch('RESET_PAYMENT_LINK_STATE')
      this.$router.push({ name: 'OrderType' })
    },
    next () {
      this.scrollToTop()
      if (this.formIsValid) this.showFeedbacks.status = true
      else {
        this.routesWizard = this.routesWizard.map((item) => {
          if (item.path === 'link-settings') item.permission = true
          return item
        })
        this.$store.dispatch('CHANGE_STATUS', 'link-settings')
        this.$router.push({ path: 'link-settings' })
      }
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "back": "Voltar ao Shop",
    "next": "Avançar"
  },
  "en-US": {
    "back": "Back to Shop",
    "next": "Next"
  }
}
</i18n>
